import { Theme } from '@/theme';
import styled from 'styled-components';

export const PageContainer = styled.div`
  background-color: ${Theme.color.white};
  flex-direction: column;
  position: relative;

  min-height: 100vh;
  display: flex;
  width: 100%;
`;
